import { render, staticRenderFns } from "./NewsTwo.vue?vue&type=template&id=c122448a&scoped=true&"
import script from "./NewsTwo.vue?vue&type=script&lang=ts&"
export * from "./NewsTwo.vue?vue&type=script&lang=ts&"
import style0 from "./NewsTwo.vue?vue&type=style&index=0&id=c122448a&lang=stylus&scoped=true&"
import style1 from "./NewsTwo.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c122448a",
  null
  
)

export default component.exports